import '../../../common/dashboard/filters/single_filters/multiple_values_filter_view.js.coffee'
Namespace 'CustomerVisualMode.Filters.SingleFilters'

class CustomerVisualMode.Filters.SingleFilters.UsersGroupFilterView extends
Common.Sessions.Filters.SingleFilters.MultipleValuesFilterView
  @NO_GROUP_VALUE = 'no-group'

  initialize: ({filter, selectedOptions, editable, title, subtitle, teams = []}) ->
    @title = title || I18n.t('common.session.filters.users_group.modal.title')
    @subtitle = subtitle || I18n.t('common.session.filters.users_group.modal.subtitle')

    values = [{
      id: CustomerVisualMode.Filters.SingleFilters.UsersGroupFilterView.NO_GROUP_VALUE,
      name: I18n.t('common.session.filters.users_group.no_team')
      optionClass: 'unassigned-icon'
    }]

    values = values.concat(teams.map((group) ->
      {
        id: group.get('id'),
        name: group.get('name')
      }
    ))

    super({
      selectedOptions: selectedOptions
      values: values
      placeholder: I18n.t('common.session.filters.users_group.modal.placeholder')
      title: @title
      subtitle: @subtitle
      editable: editable
    })

  _selector: (values) ->
    new App.SelectWithIconsView
      options: values
      valueProperty: 'id'
      descriptionProperty: 'name'
      allOptionsClass: 'all-options-icon'
      selectedOptions: @selectedOptions.map((value) -> value.id)
      placeholder: @placeholder
      editable: @editable
      multiple: true
      width: '100%'
      clearableInput: true
